export default __webpack_public_path__ + "static/media/marketing-img-second.43dd205e.jpg";